import React from 'react';
import PropTypes from 'prop-types';
import {getModelForResourceType} from 'resources/modelRegistry';

import {Text, Button, Anchor} from '@albert-io/atomic';

const ConfirmSchoolScreen = ({selectedSchool, confirmSchool, goBack}) => {
  return (
    <div className='confirm-school-screen flex flex-col items-center'>
      <div className='mb-x3 text-center leading-[150%]'>
        <Text size='regular' bold>
          Confirm your selection
        </Text>
      </div>
      <div className='mb-x3 text-center leading-[150%]'>
        <Text size='regular' color='tertiary'>
          Selecting the wrong school may prevent you from accessing content.
        </Text>
      </div>
      <div className='confirm-school-screen__selected-school-information-container mb-x3 w-full px-x2 py-x2'>
        <div className='mb-x1 text-center leading-[140%]'>
          <Text bold size='l'>
            {selectedSchool.getName()}
          </Text>
        </div>
        <div className='mb-x1 text-center leading-[140%]'>
          <Text size='s' bold>
            {selectedSchool.getIn(['district', 'name'], '')}
          </Text>
        </div>
        <div className='mb-x1 text-center leading-[150%]'>
          <Text size='m'>{selectedSchool.getFullAddress()}</Text>
        </div>
        <div className='text-center leading-[150%] font-bold'>
          <Anchor as='button' underlined onClick={goBack} className='a-text--size-m'>
            Choose a different school
          </Anchor>
        </div>
      </div>
      <Button className='w-full leading-[140%]' onClick={confirmSchool}>
        Save
      </Button>
    </div>
  );
};

ConfirmSchoolScreen.propTypes = {
  selectedSchool: PropTypes.instanceOf(getModelForResourceType('school_v5')).isRequired,
  confirmSchool: PropTypes.func,
  goBack: PropTypes.func
};

export default ConfirmSchoolScreen;
